module.exports = __webpack_public_path__ + "static/img/icon4.c3dfba0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon4.png
// module id = NuGx
// module chunks = 173